export default __webpack_public_path__ + "static/media/FNeutral.933003ee.svg";